// removed by extract-text-webpack-plugin
module.exports = {"sidebarContainer":"_3NKsgsNNbWPTRryzbHzalF","navlinks":"_2lI1ApAyJ8bl3ehFUdo2UF","sampleHover":"_31r4OlljLoUqRRjO_K-3tE"};


//////////////////
// WEBPACK FOOTER
// ./components/Navigation/sidebar.less
// module id = 1167
// module chunks = 0